/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import Box from 'core/ui/Box';
import Modules from 'modules';
import useActions from 'modules/map/useActions';
import Typography, { fontStyle } from 'core/ui/Typography';
import { gymDate, time } from 'core/utils/formatters';
import Divider from 'core/ui/Divider';
import AvatarCoach from 'components/Profile/AvatarCoach';
import Conversation from './Conversation';

const ContactConversation = ({ channel, userId }) => {
  const { request } = useActions();

  const [item, setItem] = useState(null);

  const getContactForm = () => {
    request({
      action: Modules.contactForms.actions.getContactFormByUser,
      data: {
        channelId: channel?.id,
        userId,
      },
      options: {
        onSuccess: (data) => {
          setItem(data);
        },
      },
    });
  };

  useEffect(() => {
    if (userId && channel?.id) {
      getContactForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel?.id, userId]);

  return (
    <Box>
      <Box display="flex" className="link-hover gap-10">
        {item?.user && <AvatarCoach user={item?.user} />}
        <Box flexGrow={1}>
          <Typography>{item?.name}</Typography>
          <Typography>{item?.phone}</Typography>
          <Typography>{item?.email}</Typography>
        </Box>

        <Box>
          <Typography color="textSecondary" style={fontStyle.small}>
            {gymDate(item?.createdAt)}&nbsp;{time(item?.createdAt)}
          </Typography>
        </Box>
      </Box>

      <Divider my={2} />

      <Conversation channel={channel} getContactForm={getContactForm} item={item} />
    </Box>
  );
};

export default ContactConversation;
